/* One fixed deadline for the homepage and all its sale cards. */
(() => {
  const name = 'indi-braquage-home';
  if (customElements.get(name)) return;
  class BraquageHome extends HTMLElement {
    connectedCallback() {
      clearInterval(this.timer);
      queueMicrotask(() => {
        if (!this.isConnected) return;
        this.end = Date.parse(this.dataset.end || '');
        this.launch = Date.parse(this.dataset.launch || '');
        if (!Number.isFinite(this.end) || !Number.isFinite(this.launch)) return;
        this.label = this.querySelector('[data-braquage-timer-label]');
        this.counter = this.querySelector('[data-braquage-countdown]');
        this.announcement = this.querySelector('[data-braquage-announcement]');
        this.onClick = (event) => {
          const refresh = event.target.closest('[data-braquage-refresh]');
          if (refresh) { window.location.reload(); return; }
          const button = event.target.closest('[data-filter]');
          if (!button || !this.contains(button)) return;
          const filter = button.dataset.filter;
          this.querySelectorAll('[data-filter]').forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          this.querySelectorAll('[data-braquage-product]').forEach((card) => {
            card.hidden = filter !== 'all' && card.dataset.category !== filter;
          });
        };
        this.onVisible = () => { if (!document.hidden) this.update(); };
        this.addEventListener('click', this.onClick);
        document.addEventListener('visibilitychange', this.onVisible);
        this.update();
        this.timer = setInterval(() => this.update(), 1000);
      });
    }
    update() {
      if (!this.isConnected || !this.label || !this.counter) return;
      const now = Date.now();
      const remaining = Math.max(0, Math.ceil((this.end - now) / 1000));
      const phase = remaining === 0 ? 'closed' : now < this.launch ? 'before' : 'open';
      const pad = (n) => String(n).padStart(2, '0');
      const time = `${pad(Math.floor(remaining / 3600))} h ${pad(Math.floor((remaining % 3600) / 60))} min ${pad(remaining % 60)} s`;
      this.label.textContent = remaining ? 'Fin de la vente dans' : 'Vente terminée';
      this.counter.hidden = remaining === 0;
      this.counter.textContent = time;
      this.querySelectorAll('[data-product-countdown]').forEach((label) => {
        label.textContent = remaining ? `Fin dans ${time}` : 'Vente terminée';
      });
      if (this.announcement) {
        this.announcement.textContent = phase === 'closed' ? '🇮🇹 CE BRAQUAGE EST TERMINÉ' : phase === 'before' ? `🇮🇹 BRAQUAGE À L’ITALIENNE · LIVE LE ${this.dataset.launchLabel}` : `🇮🇹 BRAQUAGE À L’ITALIENNE · FIN LE ${this.dataset.endLabel}`;
      }
      if (phase === 'closed') {
        this.querySelectorAll('[data-braquage-products], [data-braquage-waiting]').forEach((el) => { el.hidden = true; });
        const closed = this.querySelector('[data-braquage-closed]');
        if (closed) closed.hidden = false;
      } else if (phase === 'open' && this.dataset.phase === 'before') {
        const message = this.querySelector('[data-braquage-waiting-message]');
        if (message) message.textContent = 'Le Braquage est ouvert. Actualisez pour découvrir les pièces mises en ligne.';
        const refresh = this.querySelector('[data-braquage-refresh]');
        if (refresh) refresh.hidden = false;
      }
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('visibilitychange', this.onVisible);
    }
  }
  customElements.define(name, BraquageHome);
})();
